<style lang="scss">

</style>

<template>
  <section class="ui-stats-item">
    <div class="pb-0 col-12">
      <h4 class="font-weight-bold text-center title-divider top-divider">Busiest day of the week for {{activeChart}} {{filters.days}} days</h4>
    </div>


    <div class="col-12">
      <section class="d-flex full-width my-2">
        <div class="ui-spacer"></div>
        <select @change="updateActiveChart"
          style="max-width: 200px" class="form-control select-arrow" :value="activeChart">
          <option value="future">Busiest Day (Future)</option>
          <option value="past">Busiest Day (Past)</option>
        </select>
      </section>

      <div style="min-height: 350px">
        <section  v-if="!loadingStats && !loadingChart">
          <bar-chart-simple v-if="activeChart === 'past'"
                            @data-click="manageSimpleChartClick($event)"
                            y-title="Number of calls"
                            x-title="Weekday"
                            max-width="600px" chart-id="chartPast" :series="chartPastSimple"></bar-chart-simple>

          <bar-chart-simple v-if="activeChart === 'future'"
                            y-title="Number of calls"
                            x-title="Weekday"
                            max-width="600px" chart-id="chartFuture" :series="chartFutureSimple"></bar-chart-simple>

          <section class="mt-4 day-chart" v-if="activeChart === 'past' && daySlotData.length > 0 && !loadingDay">
            <bar-chart-simple v-if="activeChart === 'past'"
                              y-title="Number of calls"
                              x-title="Booking Slots"
                              :title="'Total Bookings for ' + activeDay + ' slots over last ' + filters.days + ' Days'"
                              max-width="600px" chart-id="chartDay" :series="chartDaySimple"></bar-chart-simple>
          </section>
        </section>

        <section v-else class="d-flex justify-content-center pb-4 pt-5 flex-wrap">
          <p class="full-width d-flex justify-content-center">Getting Stats...</p>
          <b-spinner variant="primary"></b-spinner>
        </section>
      </div>
    </div>
  </section>
</template>

<script>
  import Vue from 'vue';
  import { mapState } from 'vuex';
  import VisitsService from '../../../services/VisitService';
  import HelperService from '../../../services/HelperService';
  import BarChartSimple from '@/components/charts/BarChartSimple';

  export default {
    props: {
      filters: {
        required: true,
        type: Object,
      },
    },
    components: {
      BarChartSimple,
    },
    watch: {
      filters: {
        handler() {
          this.getBusiestDayStats();
        },
        deep: true,
      },
      activeChart() {
        this.loadingChart = true;

        setTimeout(() => {
          this.loadingChart = false;
        }, 500);
      }
    },
    computed: mapState({
      activeChart: state => state.stats.activeBusiestChart
    }),
    data() {
      return {
        helperService: new HelperService(),
        loadingStats: true,
        activeDay: '',
        stats: null,
        slotStats: null,
        daySlotData: [],
        loadingDay: false,
        chartFutureSimple: null,
        chartPastSimple: null,
        chartDaySimple: null,
        loadingChart: false,
      };
    },
    mounted() {
      this.getBusiestDayStats();
    },
    methods: {
      updateActiveChart(e) {
        this.$store.commit('stats/SET_ACTIVE_BUSIEST_CHART', e.target.value);
      },
      getBusiestDayStats() {
        this.loadingStats = true;

        if (this.filters.prisonId || this.filters.prisonGroupId) {
          return VisitsService.getVisitBusiestDayOfWeek(this.filters).then((res) => {
            this.stats = res.data;
            this.chartPastSimple = this.createChartJsChart(this.stats.past_days);
            this.chartFutureSimple = this.createChartJsChart(this.stats.future_days);
          }).catch((err) => {
            console.log('could not get busiest day', err);
            this.$toasted.error('Error getting busiest day, please refresh and try again');
          }).finally(() => {
            setTimeout(() => {
              this.loadingStats = false;
            }, 1000);
          });
        }

        return null;
      },
      createChartJsChart(dayData) {
        const weekdays = this.helperService.getWeekdays();
        let chart = {
          data: [],
          labels: [],
        };

        weekdays.forEach((day) => {
          chart.data.push(dayData[day]);
          chart.labels.push(this.$options.filters.capEachWord(day));
        });

        return chart;
      },
      manageSimpleChartClick(data) {
        this.getSlotDayData(data.label);
      },
      getSlotDayData(day) {
        this.setActiveDay(day);

        if(!this.slotStats) { // get the stats if not already received
          this.getBookingSlotStats();
        } else {
          this.setDaySlotData(this.activeDay);
        }
      },
      getBookingSlotStats() {
        return VisitsService.getBookingSlotUsageStats(this.filters).then((res) => {
          this.slotStats = res.data.booking_slots;
          this.setDaySlotData(this.activeDay);
        }).catch((err) => {
          console.log('could not get call stats', err);
          this.$toasted.error('Error getting call stats, please refresh and try again');
        }).finally(() => {
          setTimeout(() => {
            this.loadingStats = false;
          }, 1000);
        });
      },
      setActiveDay(day) {
        this.activeDay = day.toLowerCase();
      },
      setDaySlotData(day) {
        this.loadingDay = true;
        this.setActiveDay(day);

        this.daySlotData = this.slotStats.filter((slot) => {
          return slot.weekday.toLowerCase() === day;
        });

        this.chartDaySimple = this.setDayChartDataSimple();
        this.scrollDayChartIntoView();
      },
      setDayChartDataSimple() {
        let chart = {
          data: [],
          labels: [],
        };

        const dayData = this.daySlotData;

        dayData.forEach((slot) => {
          chart.data.push(slot.bookings);
          chart.labels.push(slot.name);
        });

        return chart;
      },
      scrollDayChartIntoView() {
        Vue.nextTick(() => { // delay to refresh the ui
          this.loadingDay = false;

          Vue.nextTick(() => {
            let chart = document.querySelector('.day-chart');

            if(chart) {
              chart.scrollIntoView();
            }
          });
        });
      },
    },
  };
</script>
